/* StoreForge selected-theme variant media adapter.
 * Native theme behavior runs first. This adapter only corrects a product page
 * when the selected Shopify variant has an image but the gallery did not move. */
(() => {
  if (window.__storeforgeVariantMediaAdapter) return;
  window.__storeforgeVariantMediaAdapter = true;

  const handle = () => {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  };
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const imageKey = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      return decodeURIComponent(url.pathname).replace(/_[0-9]+x[0-9]*?(?=\.[a-z]+$)/i, '').toLowerCase();
    } catch (_error) {
      return String(value).split(/[?#]/)[0].toLowerCase();
    }
  };
  const imageSource = (image) => image && (image.currentSrc || image.getAttribute('src') || '');
  const variantImage = (variant) => {
    const featured = variant && variant.featured_image;
    return typeof featured === 'string' ? featured : featured && (featured.src || featured.url);
  };
  let productRequest = null;
  const product = () => {
    const productHandle = handle();
    if (!productHandle) return Promise.resolve(null);
    if (!productRequest) {
      productRequest = fetch(root() + 'products/' + encodeURIComponent(productHandle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      }).then((response) => response.ok ? response.json() : null).catch(() => null);
    }
    return productRequest;
  };
  const selectedVariant = (data, changed) => {
    if (!data || !Array.isArray(data.variants)) return null;
    const form = changed && changed.closest ? changed.closest('form') : null;
    const candidates = [
      form && form.querySelector('[name="id"]'),
      document.querySelector('form[action*="/cart/add"] [name="id"]'),
    ].filter(Boolean);
    for (const input of candidates) {
      const match = data.variants.find((variant) => String(variant.id) === String(input.value));
      if (match) return match;
    }
    const queryId = new URL(window.location.href).searchParams.get('variant');
    const queryMatch = data.variants.find((variant) => String(variant.id) === String(queryId));
    if (queryMatch) return queryMatch;
    const chosen = Array.from(document.querySelectorAll(
      'main input[type="radio"]:checked, main select option:checked'
    )).map((control) => String(control.value || control.textContent || '').trim()).filter(Boolean);
    return data.variants.find((variant) => Array.isArray(variant.options)
      && variant.options.every((option) => chosen.includes(String(option).trim()))) || null;
  };
  const activeProductImage = () => {
    const selectors = [
      'main media-gallery [data-media-id].is-active img',
      'main [data-product-media].is-active img',
      'main .product__media-item.is-active img',
      'main .product-gallery__media.is-active img',
    ];
    for (const selector of selectors) {
      const image = document.querySelector(selector);
      if (image) return image;
    }
    return Array.from(document.querySelectorAll('main img')).find((image) => {
      const bounds = image.getBoundingClientRect();
      const style = window.getComputedStyle(image);
      return bounds.width >= 180 && bounds.height >= 180 && style.visibility !== 'hidden' && style.display !== 'none';
    }) || null;
  };
  const activate = async (changed) => {
    const data = await product();
    const variant = selectedVariant(data, changed);
    const target = variantImage(variant);
    const targetKey = imageKey(target);
    if (!targetKey) return;
    const active = activeProductImage();
    if (active && imageKey(imageSource(active)) === targetKey) return;

    const images = Array.from(document.querySelectorAll('main img'));
    const matchingImage = images.find((image) => imageKey(imageSource(image)) === targetKey);
    const mediaItem = matchingImage && matchingImage.closest('[data-media-id]');
    const mediaId = mediaItem && mediaItem.getAttribute('data-media-id');
    const gallery = (mediaItem && mediaItem.closest('media-gallery')) || document.querySelector('main media-gallery');
    if (gallery && mediaId && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId, true);
    } else if (matchingImage) {
      const targetControl = matchingImage.closest('button, a, [role="button"]');
      if (targetControl && typeof targetControl.click === 'function') targetControl.click();
    }

    window.setTimeout(() => {
      const current = activeProductImage();
      if (!current || imageKey(imageSource(current)) === targetKey) return;
      const picture = current.closest('picture');
      if (picture) picture.querySelectorAll('source').forEach((source) => source.removeAttribute('srcset'));
      current.removeAttribute('srcset');
      current.removeAttribute('sizes');
      current.setAttribute('src', target);
      if (variant && variant.public_title) current.setAttribute('alt', String(variant.public_title));
    }, 180);
  };
  const schedule = (changed) => {
    window.setTimeout(() => activate(changed), 350);
    window.setTimeout(() => activate(changed), 900);
  };
  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!handle() || !target || !target.matches || !target.matches(
      'main input[type="radio"], main select, main input[name="id"]'
    )) return;
    schedule(target);
  }, true);
})();
